import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { TemplateLayoutLanguageService } from '@fi-app/template/template-layout-language.service';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { FiDialogCloseReason } from '@fi-shared/fi-dialogs/fi-dialogs-close-reason';
import { IDropdownSelectLanguageSettingsItem } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { isDefined } from '@fi-shared/utils';

interface IFiDialogSelectLanguageData {
    languageId: number;
    saveLanguageOnChange: boolean;
    itemLanguageIds: number[];
}

@Component({
    selector: 'fi-dialog-select-language',
    templateUrl: './dialog-select-language.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./dialog-select-language.component.scss'],
    standalone: false,
})
export class FiDialogSelectLanguageComponent
    extends FiDialogsContentBase<IFiDialogSelectLanguageData, number>
    implements OnInit
{
    DataSet: IDropdownSelectLanguageSettingsItem[];
    contentLanguageService: ContentLanguagesService;
    templateLayoutLanguageService: TemplateLayoutLanguageService;

    ngOnInit() {
        this.contentLanguageService = this.injector.get(ContentLanguagesService);
        this.templateLayoutLanguageService = this.injector.get(TemplateLayoutLanguageService);
        this.DataSet = this.contentLanguageService
            .GetDropdownListSettingsLanguage()
            .dataSet.filter(
                (item) => !isDefined(this.data.itemLanguageIds) || this.data.itemLanguageIds.indexOf(item.Id) !== -1,
            );
    }

    selectLanguageClick(id: number) {
        if (this.data.saveLanguageOnChange !== false) this.templateLayoutLanguageService.selectLanguage(id);

        this.dialogRef.close({
            value: id,
            reason: FiDialogCloseReason.YesButton,
        });
    }
}
